export default __webpack_public_path__ + "static/media/add-blue-circle-fill.ab83e6ce.svg";